
import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { FormatSourceComplementor } from "../../../../domain/developer";

@Component
export default class FormatDebuggableMixin extends Mixins() {
  get registry(): DomainRegistry {
    return DomainRegistry.instance;
  }

  get complementor(): FormatSourceComplementor {
    return new FormatSourceComplementor();
  }

  toComplementedSource(source: any): any {
    return this.complementor.toComplementedSource(source);
  }

  areEqual(a: any, b: any): boolean {
    return (JSON.stringify(a, null, 2) === JSON.stringify(b, null, 2));
  }

  stringifyOr(source: any, defaultValue: string): string {
    return source
      ? JSON.stringify(source, null, 2)
      : defaultValue;
  }
}
